import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'

export const TopInfoBox = styled.div<{ mode: Theme }>`
  font-family: var(--large-font-family);
  font-size: ${sys.typescale[16].size};
  font-weight: ${sys.fontWeight.medium};
  line-height: ${sys.typescale[16].lineHeight};
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 20px 16px 20px;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: ${({ mode }) => sys[mode].elevation[100].background};
`

export const TopInfoLeft = styled.div`
  display: flex;
`

export const TopInfoRight = styled.div`
  min-width: 126px;
`

export const StyledTermContainer = styled.div`
  overflow: hidden;
`

interface StyledTermContentProps {
  testId?: string
  mode: Theme
}

export const StyledTermContent = styled.div.attrs<StyledTermContentProps>((props) => ({
  [AUTO_ATTR_KEY]: props.testId ? props.testId : AutomationId.insightModal.selectedTerm
}))<StyledTermContentProps>`
  color: ${({ mode }) => sys[mode].text.primary};
  font-size: ${sys.typescale[16].size};
  font-weight: ${sys.fontWeight.medium};
  line-height: ${sys.typescale[16].lineHeight};
  /* line-clamp */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  width: fit-content;
`
